import React, {Component} from 'react';
import {
  View,
  Text,
  TextInput,
  ImageBackground,
  Image,
  Dimensions,
  TouchableOpacity,
  Platform,
  ScrollView
} from 'react-native';
import styles from '../../style/scanpack';
import {getKeyboardSuppressionProps, KeyboardSuppressionSync} from '../../hooks/useKeyboardSuppression';
import globalStyles from '../../style/global';
import restart from '../../../assets/restart.png';
import note from '../../../assets/note.png';
import deleteImage from '../../../assets/delete.png';
import toggle from '../../../assets/dotToggle.png';
import {LinearGradient} from 'expo-linear-gradient';
import backImage from '../../../assets/bg_left.png';
import backNewImage from '../../../assets/Left_new2.jpg';
import upArrow from '../../../assets/up_arrow.png';
import downArrow from '../../../assets/down_arrow.png';
import placeholder from '../../../assets/placeholder.jpg';
import {fontFamily} from '../../helpers/fontFamily';
import {sortUnscannedItems} from './boxChampSort';
import BoxChampZonedList from './BoxChampZonedList';
import {createGuidedViewMemo, createLiveTreeMemo} from './boxChampGuided';
import moment from 'moment';
import * as Clipboard from 'expo-clipboard';
import ScanImageComponent from './ScanImageComponent';
import OrderItem from '../../commons/orderItem';
import OrderItemImage from '../../commons/orderItemImage';
import OrderKitItem from '../../commons/orderKitItem';
import ActionBarButtons from './actionBarButtons';
import DisplayOrderNumber from '../../commons/displayOrderNumber';
import OrderItemListMenu from '../../commons/orderItmesListMenu';
import DisplayLogs from '../../commons/displayLogs';
import ScanButtonContainer from './scanButtonContainer';
import I18n from 'i18n-js';
import CustomScrollBar from '../../commons/customScrollBar';
import NotFulfilledItems from './NotFulfilledItems';
import { checkIfAllFromNotFulfilled, getUnscannedItemsTitle } from './scanBarcodeFunctions';
{
  /* <ScanImageComponent img={item.images[0].image}/>*/
}
let count = 0;
export default class UnscannedItems extends Component {
  constructor(props) {
    super(props);
    this.state = {
      actionBarShow: false,
      unscannedItemPerPage: 1,
      scanPlaceHolderValue: 'Ready For Product Scan',
      windowWidth: Dimensions.get('window').width,
      imageFlag: [],
      imageUnscanFlagMob: [],
      imageScannedFlagMob: [],
      isBarcodeEnter: false,
      boxChampSortMode: 'location'
    };
    this.unscannedInputField = React.createRef();
    this.getGuidedView = createGuidedViewMemo();
    this.getLiveTree = createLiveTreeMemo();
  }

  renderUnscannedCard = (item, index) => (
    <View
      key={item?.order_item_id}
      testID={`boxchamp-unscanned-item-${item?.order_item_id}`}
      dataSet={{componentName: 'singleProductParent'}}>
      <View style={{margin: 1}} dataSet={{componentName: `singleProduct-${index}`}}>
        {(item && item.product_type === 'single') ||
        (item && item.product_type === 'depends') ? (
          <View style={styles.scanPackSingleItemContainer}>
            <OrderItem
              item={item}
              redirectToItemDetail={it => {
                this.props.redirectToItemDetail(it);
              }}
              testID={'redirectToItem'}
            />
            <OrderItemImage
              item={item}
              shuffleTheItem={sku => {
                this.props.shuffleTheItem(sku);
              }}
              testID={'shuffleItem'}
              listType={'unscanned'}
            />
          </View>
        ) : (
          <OrderKitItem
            item={item}
            index={index}
            listType={'unscanned'}
            redirectToItemDetail={it => {
              this.props.redirectToItemDetail(it);
            }}
            shuffleTheItem={sku => {
              this.props.shuffleTheItem(sku);
            }}
            shuffleTheKitItem={(kitSku, itemSku) => {
              this.props.shuffleTheItem(kitSku, itemSku);
            }}
          />
        )}
      </View>
    </View>
  );

  orderDetail = order => {
    // if(order){
    // this.props.leaveComponent(this.props.order , "submitLog")
    this.props.navigation.navigate('OrderDetail', {data: order});
    // }
  };

  updateDimensions = () => {
    this.setState({windowWidth: window.innerWidth});
  };

  componentDidMount() {
    this._isMounted = true;
    window.addEventListener('resize', this.updateDimensions());
    // FE-3: load this user's saved unscanned-list sort preference (default 'location').
    if (this.props.GetBoxChampSortPreference) {
      this.props
        .GetBoxChampSortPreference()
        .then(mode => mode && this._isMounted && this.setState({boxChampSortMode: mode}));
    }
  }

  toggleBoxChampSort = () => {
    const mode = this.state.boxChampSortMode === 'packing' ? 'location' : 'packing';
    this.setState({boxChampSortMode: mode});
    if (this.props.SaveBoxChampSortPreference) {
      this.props.SaveBoxChampSortPreference(mode);
    }
  };

  getSortedUnscanned = Order => {
    const items = Order && Order.unscanned_items;
    const placement = this.props.Order || Order;
    const mode = this.state.boxChampSortMode;
    const boxes = placement && placement.boxes;
    const oib = placement && placement.order_item_boxes;
    const c = this._sortMemo;
    if (c && c.items === items && c.mode === mode && c.boxes === boxes && c.oib === oib) {
      return c.result;
    }
    const result = sortUnscannedItems(items, mode, boxes, oib);
    this._sortMemo = {items, mode, boxes, oib, result};
    return result;
  };

  componentWillUnmount() {
    this._isMounted = false;
    window.removeEventListener('resize', this.updateDimensions);
  }
  calculateScanned = () => {
    let Order = this.props.order.order;
    let localCount = 0;
    this.props.order &&
      Order &&
      Order.scanned_items &&
      Order.scanned_items.length > 0 &&
      Order.scanned_items.map(item => {
        localCount = localCount + item.scanned_qty;
      });
    return localCount;
  };
  copyOrderNumberToClipboard = async () => {
    await Clipboard.setStringAsync(`${this.props.order.order.increment_id}`);
  };
  handlePassButton = (item) =>{
    if(this.props.barcodeState !== ''){
      this.props.scanBarcode()
      return
    }
    this.props.clickScan(item)
  }

  showMore = () => {
    let perPage =
      this.state.unscannedItemPerPage + 1;
    this.setState({
      unscannedItemPerPage: perPage
    });
  }

  render() {
    let props = this.props;
    let Order = props.order.order;
    const sortedUnscanned = this.getSortedUnscanned(Order);
    const guidedView = this.getGuidedView(
      this.getLiveTree(Order, this.props.notFullFilledItems),
      [this.props.Order, Order]
    );
    const boxChampPlacement = this.props.Order || Order;
    const boxChampSortAvailable =
      !guidedView &&
      !!this.props?.bothSettings?.data?.data?.general_setting?.is_box_champ &&
      boxChampPlacement &&
      Array.isArray(boxChampPlacement.order_item_boxes) &&
      boxChampPlacement.order_item_boxes.length > 0;
    let localCount = 0;
    Order?.unscanned_items &&
      Order.unscanned_items.length > 0 &&
      Order.unscanned_items.map(item => {
        if (
          item.child_items &&
          item.child_items.length > 0 &&
          item.product_type === 'individual'
        ) {
          item.child_items.map(childItem => {
            localCount = localCount + childItem.qty_remaining;
          });
        } else {
          localCount = localCount + item.qty_remaining;
        }
      });
    let scannedCount = this.calculateScanned();
    count = localCount;
    const windowHeight = Dimensions.get('window').height;
    let perPage = this.state.unscannedItemPerPage * 10;

    const { testPlatform } = this.props;
    const currentPlatform = testPlatform || Platform.OS;
    

    return (
      <React.Fragment>
        {Order && (
          <View
            style={
              currentPlatform === 'web'
                ? styles.unscannedItemContainerWeb
                : {width: '100%', height: '100%', backgroundColor: '#666666'}
            }
          >
            {Platform.OS === 'web' ? (
              <View style={{flex: 1, height: '100%'}}>
                {this.state.windowWidth >= 900 ? (
                  <ImageBackground
                    key="imageBackgroundContainer"
                    source={backNewImage}
                    style={{height: '100%'}}
                  >
                    <Text
                      style={[
                        styles.unscannedItemTitleWeb,
                        {fontFamily: fontFamily.font600}
                      ]}
                      dataSet = {{componentName: 'unscannedCount'}}>
                      {' '}
                      {getUnscannedItemsTitle(Order.unscanned_items, count, I18n.t("nextItems.unScannedLabel"))}
                    </Text>
                    {boxChampSortAvailable && (
                      <TouchableOpacity
                        testID="boxchamp-sort-toggle"
                        onPress={this.toggleBoxChampSort}
                        style={{
                          alignSelf: 'flex-start',
                          marginLeft: 8,
                          marginBottom: 4,
                          paddingHorizontal: 10,
                          paddingVertical: 4,
                          backgroundColor: 'rgba(0,0,0,0.35)',
                          borderRadius: 12
                        }}>
                        <Text
                          testID={`boxchamp-sort-mode-${this.state.boxChampSortMode}`}
                          style={{color: '#ffffff', fontSize: 13, fontFamily: fontFamily.font600}}>
                          {this.state.boxChampSortMode === 'packing' ? 'Sort: Packing order' : 'Sort: Location'}
                        </Text>
                      </TouchableOpacity>
                    )}
                    <View style={{maxHeight: window.innerHeight - 70}}>
                    <CustomScrollBar showDefaultStyles={false} >
                    {guidedView ? (
                      <BoxChampZonedList
                        view={guidedView}
                        renderItem={this.renderUnscannedCard}
                        onOpenOptions={this.props.openBoxChampOptions}
                      />
                    ) : (
                      <React.Fragment>
                        {props?.order?.order &&
                        props.order.order.unscanned_items &&
                        props.order.order.unscanned_items.length > 0 && (
                          sortedUnscanned
                            .slice(0, perPage)
                            .map((item, index) => this.renderUnscannedCard(item, index))
                        )}
                        {props.order.order.unscanned_items &&
                          props.order.order.unscanned_items.length >= perPage && (
                            <View>
                                <TouchableOpacity
                                  testID={'showMoreButton'}
                                  onPress={() =>this.showMore()}
                                >
                                  <Text
                                    style={styles.showMoreButtonText}
                                  >
                                    Show More
                                  </Text>
                                </TouchableOpacity>
                            </View>
                          )}
                      </React.Fragment>
                    )}
                      {!checkIfAllFromNotFulfilled(Order.unscanned_items) && (
                        <NotFulfilledItems
                          notFullFilledItems={props.notFullFilledItems}
                          redirectToItemDetail={(item) => {this.props.redirectToItemDetail(item)}}
                          shuffleTheItem={(sku) => {this.props.shuffleTheItem(sku)}}
                        />
                      )}
                    </CustomScrollBar>
                    </View>
                  </ImageBackground>
                ) : (
                  <View>
                    <View style={{height: windowHeight - 70, width: '100%'}}>
                      <View style={styles.actionButtonsView}>
                        <DisplayOrderNumber
                         orderDetail={() =>
                          this.props.userData.role.access_role && (
                            this.orderDetail(Order)
                          )}
                         incrementId={Order.increment_id}
                         actionBarShow={this.state.actionBarShow}
                         setActionBarState={() => {
                          let actionBarShow = !this.state.actionBarShow;
                          this.setState({actionBarShow});
                         }}
                         downArrow={downArrow}
                         upArrow={upArrow}
                         copyOrderNumberToClipboard={this.copyOrderNumberToClipboard}
                         id={'orderDetail'}
                        />
                        {this.state.actionBarShow && (
                          <ActionBarButtons
                           width={this.state.windowWidth}
                           onPressRestartOrder={this.props.restartButton}
                           restartButtonDesign={styles.restartButtonDesign}
                           onPressGetOrderData={()=>{this.props.getOrderData(Order.increment_id)}}
                           reloadButtonDesign={styles.noteSaveButtonDesign}
                           onPressAddNote={this.props.addNote}
                          />
                        )}
                      </View>
                      <LinearGradient
                        style={styles.scanBarcodeGradient}
                        start={{x: 0, y: 1}}
                        end={{x: 0, y: 0}}
                        colors={['#142130', '#304454']}
                      >
                        <View style={{flexDirection: 'row'}}>
                          <View
                            style={styles.scanBarcodeContainer}
                          >
                            <LinearGradient
                              start={{x: 0, y: 1}}
                              end={{x: 0, y: 0}}
                              colors={['#6384ff', '#1329ff', '#35096c']}
                              style={styles.scanBarcodeSubGradient}
                            />
                          </View>
                            <React.Fragment>
                              <TextInput
                                 testID="test-input"
                                value={this.props.barcodeState}
                                autoFocus={false}
                                ref={this.props.InputField}
                                {...getKeyboardSuppressionProps(
                                  this.props.scanPackSetting
                                    ?.suppress_software_keyboard,
                                )}
                                onSubmitEditing={this.props.scanBarcode}
                                onKeyPress={(e)=>{
                                  if(e.key === 'Enter'){
                                    this.props.scanBarcode()
                                  }
                                }}
                                onChangeText={this.props.stateUpdate}
                                style={styles.scanBarCodeInputMobile}
                                placeholder={this.state.scanPlaceHolderValue}
                                placeholderTextColor={'#4c4c4b'}
                                onBlur={() => {
                                  const blurValue =
                                    Platform.OS === 'web'
                                      ? I18n.t("nextItems.clickScanLabel")
                                      : I18n.t("nextItems.tabHereLabel");;
                                  this.setState({
                                    scanPlaceHolderValue: blurValue
                                  });
                                }}
                                onFocus={() =>
                                  this.setState({
                                    scanPlaceHolderValue:
                                    I18n.t("nextItems.readyForScanLabel")
                                  })
                                }
                              />
                            <KeyboardSuppressionSync
                              inputRef={this.props.InputField}
                            />
                            <ScanButtonContainer
                              Order={Order}
                              popInternet={this.props.popInternet}
                              scanAllItem={this.props.scanAllItem}
                              windowWidth={this.state.windowWidth}
                              setType={this.props.setType}
                              checkCount={this.props.checkCount}
                              scanAllOption={this.props.scanPackSetting.scan_all_option}
                              typeScanState={this.props.typeScanState}
                              handlePassButton = {this.handlePassButton}
                              isBarcodeEnter = {this.props.isBarcodeEnter}
                              setIsBarcodeEnter = {this.props.setIsBarcodeEnter}
                            />
                          </React.Fragment>
                        </View>
                      </LinearGradient>
                      <OrderItemListMenu
                        showScannedList={this.props.showScannedList}
                        showUnScannedList={this.props.showUnscannedList}
                        showLogList={this.props.showLogList}
                        unScannedCount={count}
                        scannedCount={scannedCount}
                        scannedList={this.props.scannedList}
                        unScannedList={this.props.unscannedList}
                        logList={this.props.logList}
                        navButtonLeft={this.props.navButton}
                        icon={downArrow}
                        unScannedLabel={getUnscannedItemsTitle(Order.unscanned_items)}
                      />
                      <ScrollView>
                        {props.scannedList && guidedView && (
                          <BoxChampZonedList
                            view={guidedView}
                            renderItem={this.renderUnscannedCard}
                            onOpenOptions={this.props.openBoxChampOptions}
                          />
                        )}
                        {!guidedView &&
                        props.scannedList &&
                        props.order &&
                        props.order.order &&
                        props.order.order.unscanned_items &&
                        props.order.order.unscanned_items.length > 0
                          && props.scannedList &&
                            props.order.order.unscanned_items &&
                            sortedUnscanned
                              .slice(0, perPage)
                              .map((item, index) => {
                                return (
                                  <View
                                   key={item?.id}
                                  >
                                    {(item && item.product_type === 'single') ||
                                    (item &&
                                      item.product_type === 'depends') ? (
                                      <View
                                        key={item?.id}
                                        style={styles.scanPackSingleItemContainer}
                                      >
                                        <OrderItem
                                         item={item}
                                         index={index}
                                         testID={'redirectToItem'}
                                         redirectToItemDetail={(item)=>{this.props.redirectToItemDetail(item)}}
                                        />
                                        <OrderItemImage
                                          item={item}
                                          testID={'shuffleItem'}
                                          listType={'scanned'}
                                          shuffleTheItem={(sku)=>{this.props.shuffleTheItem(sku)}}
                                        />
                                      </View>
                                    ) : (
                                      <OrderKitItem
                                        item={item}
                                        index={index}
                                        windowWidth={this.state.windowWidth}
                                        redirectToItemDetail={(item)=>{this.props.redirectToItemDetail(item)}}
                                        shuffleTheItem={(sku)=>{this.props.shuffleTheItem(sku)}}
                                        shuffleTheKitItem={(kitSku,itemSku)=>{this.props.shuffleTheItem(kitSku,itemSku)}}
                                      />
                                    )}
                                  </View>
                                );
                              })}
                          : props.scannedList && (
                              <View style={globalStyles.p_10}>
                                {/* <Text style={styles.scannedItemNameText}>
                                    No more item remaining to scan
                                  </Text> */}
                              </View>
                            )
                        {props.scannedList && !checkIfAllFromNotFulfilled(Order.unscanned_items) && (
                          <NotFulfilledItems
                            notFullFilledItems={props.notFullFilledItems}
                            redirectToItemDetail={(item) => {this.props.redirectToItemDetail(item)}}
                            shuffleTheItem={(sku) => {this.props.shuffleTheItem(sku)}}
                          />
                        )}
                        {props.unscannedList && (
                          <React.Fragment>
                            {Order.scanned_items &&
                            Order.scanned_items.length > 0 ? (
                              Order.scanned_items.map((item, index) => {
                                return (
                                  <View
                                   key={item?.id}
                                  >
                                    {item.scanned_qty > 0 && (
                                      <View
                                        testID='scannedListContainer'
                                        key={item?.id}
                                        style={styles.scanPackSingleItemContainer}
                                      >
                                        <OrderItem
                                         item={item}
                                         testID={'redirectToItem'}
                                         redirectToItemDetail={(item)=>{this.props.redirectToItemDetail(item)}}
                                        />
                                        <OrderItemImage
                                         item={item}
                                         shuffleTheItem={()=>{}}
                                         listType={'unscanned'}
                                        />
                                      </View>
                                    )}
                                  </View>
                                );
                              })
                            ) : (
                              <View style={globalStyles.p_10}>
                                <Text style={styles.scannedItemNameText}>
                                  No Record
                                </Text>
                              </View>
                            )}
                          </React.Fragment>
                        )}
                        {this.props.logList && (
                          <React.Fragment>
                            {props.localLogs && props.localLogs.length > 0 ? (
                              <DisplayLogs
                               logs={props.localLogs}
                               sliceNum={10}
                              />
                              )
                              : (
                              <View style={globalStyles.p_10}>
                                <Text style={styles.scannedItemNameText}>
                                  No Record
                                </Text>
                              </View>
                            )}
                          </React.Fragment>
                        )}
                      </ScrollView>
                    </View>
                  </View>
                )}
              </View>
            ) : (
              <View>
                <View style={{height: windowHeight - 90, width: '100%'}}>
                  <View style={styles.actionButtonsView}>
                    <View style={{position: 'relative'}}>
                      <TouchableOpacity
                        onPress={() =>
                          this.props.userData.role.access_role ? (
                            this.orderDetail(Order)
                          ) : (
                            <></>
                          )
                        }
                        style={{marginRight: 45, marginLeft: 45}}
                      >
                        <Text
                          numberOfLines={1}
                          ellipsizeMode="tail"
                          style={[
                            styles.nowScanningTextView,
                            {textAlign: 'center', margin: 8}
                          ]}
                        >
                          {Order.increment_id}
                        </Text>
                      </TouchableOpacity>
                      <TouchableOpacity
                        onPress={() => {
                          let actionBarShow = !this.state.actionBarShow;
                          this.setState({actionBarShow});
                        }}
                        style={{position: 'absolute', right: 10}}
                      >
                        <Image
                          style={[
                            styles.nowScanningTextView,
                            {
                              textAlign: 'center',
                              marginBottom: 8,
                              marginTop: 8
                            }
                          ]}
                          source={toggle ? toggle : ''}
                        />
                      </TouchableOpacity>
                    </View>
                    {this.state.actionBarShow && (
                      <View style={styles.actionButtonInnerView}>
                        <TouchableOpacity
                          style={styles.restartButtonDesign}
                          onPress={this.props.restartButton}
                        >
                          <View
                            style={{
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center'
                            }}
                          >
                            <Image
                              style={styles.actionImages}
                              source={restart ? restart : ''}
                            />
                            {this.state.windowWidth > 375 && (
                              <React.Fragment>
                                <View
                                  style={{
                                    flexDirection: 'column',
                                    alignItems: 'center'
                                  }}
                                >
                                  <Text style={styles.actionButtonText}>
                                    Restart
                                  </Text>
                                  <Text style={styles.actionButtonText}>
                                    Order
                                  </Text>
                                </View>
                              </React.Fragment>
                            )}
                          </View>
                        </TouchableOpacity>
                        <TouchableOpacity
                          style={styles.noteSaveButtonDesign}
                          onPress={this.props.saveChanges}
                        >
                          <View
                            style={globalStyles.displayTypeOne}
                          >
                            <i
                              className="icon-trash"
                              style={{color: 'white', fontSize: '24px'}}
                            ></i>
                            {/* <Image style={styles.actionImages}
                                source={deleteImage ? deleteImage : ""} /> */}
                            {this.state.windowWidth > 375 && (
                              <React.Fragment>
                                <View
                                  style={{
                                    flexDirection: 'column',
                                    alignItems: 'center'
                                  }}
                                >
                                  <Text style={styles.actionButtonText}>
                                    Remove
                                  </Text>
                                  <Text style={styles.actionButtonText}>
                                    Item
                                  </Text>
                                </View>
                              </React.Fragment>
                            )}
                          </View>
                        </TouchableOpacity>
                        <TouchableOpacity
                          style={styles.noteSaveButtonDesign}
                          onPress={this.props.addNote}
                        >
                          <View
                            style={globalStyles.displayTypeOne}
                          >
                            <Image
                              style={styles.actionImages}
                              source={note ? note : ''}
                            />
                            {this.state.windowWidth > 375 && (
                              <React.Fragment>
                                <View
                                  style={{
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    marginLeft: 2
                                  }}
                                >
                                  <Text style={styles.actionButtonText}>
                                    Add
                                  </Text>
                                  <Text style={styles.actionButtonText}>
                                    Note
                                  </Text>
                                </View>
                              </React.Fragment>
                            )}
                          </View>
                        </TouchableOpacity>
                      </View>
                    )}
                  </View>
                  <View style={{backgroundColor: '#2c2c2c', padding: 10}}>
                    <View style={{flexDirection: 'row'}}>
                      <View
                        style={styles.scanBarcodeContainer}
                      >
                        <View
                          style={{
                            height: 10,
                            width: 10,
                            backgroundColor: '#5f80ff',
                            borderRadius: 30,
                            marginRight: 10,
                            shadowOffset: {width: 0, height: 0},
                            shadowColor: '#fff',
                            shadowOpacity: 1.0
                          }}
                        ></View>
                      </View>
                      {Order &&
                      Order.unscanned_items &&
                      Order.unscanned_items[0] &&
                      Order.unscanned_items[0].product_type === 'individual' ? (
                        <React.Fragment>
                          <TextInput
                          testID='scanner'
                            value={this.props.barcodeState}
                            autoFocus={false}
                            ref={this.props.InputField}
                            {...getKeyboardSuppressionProps(
                              this.props.scanPackSetting
                                ?.suppress_software_keyboard,
                            )}
                            onSubmitEditing={this.props.scanBarcode}
                            onKeyPress={(e)=>{
                              if(e.key === 'Enter'){
                                this.props.scanBarcode()
                              }
                            }}
                            onChangeText={this.props.stateUpdate}
                            style={styles.scanBarCodeInputMobile}
                            placeholder="Ready For Product Scan"
                            placeholderTextColor={'#4c4c4b'}
                          />
                          <KeyboardSuppressionSync
                            inputRef={this.props.InputField}
                          />
                          <TouchableOpacity
                            onLongPress={this.props.scanAllItem}
                            delayLongPress={1000}
                            style={styles.passButton}
                          >
                            <Text
                              style={styles.passButtonText}
                            >
                              Pass
                            </Text>
                          </TouchableOpacity>
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          <TextInput
                            value={this.props.barcodeState}
                            autoFocus={false}
                            ref={this.props.InputField}
                            {...getKeyboardSuppressionProps(
                              this.props.scanPackSetting
                                ?.suppress_software_keyboard,
                            )}
                            onSubmitEditing={this.props.scanBarcode}
                            onKeyPress={(e)=>{
                              if(e.key === 'Enter'){
                                this.props.scanBarcode()
                              }
                            }}
                            onChangeText={this.props.stateUpdate}
                            style={styles.scanBarCodeInputMobile}
                            placeholder="Ready For Product Scan"
                            placeholderTextColor={'#4c4c4b'}
                          />
                          <KeyboardSuppressionSync
                            inputRef={this.props.InputField}
                          />
                          <TouchableOpacity
                            onLongPress={this.props.scanAllItem}
                            delayLongPress={1000}
                            style={styles.passButton}
                          >
                            <Text
                              style={styles.passButtonText}
                            >
                              Pass
                            </Text>
                          </TouchableOpacity>
                        </React.Fragment>
                      )}
                    </View>
                  </View>
                  <ScrollView>
                    {props.order &&
                    props.order.order &&
                    props.order.order.unscanned_items &&
                    props.order.order.unscanned_items.length > 0 ? (
                      props.order.order.unscanned_items &&
                      props.order.order.unscanned_items.map((item, index) => {
                        return (
                          <View>
                            {(item && item.product_type === 'single') ||
                            (item && item.product_type === 'depends') ? (
                              <View
                                key={index}
                                style={{
                                  flexDirection: 'row',
                                  margin: 0,
                                  borderRadius: 30,
                                  borderWidth: 4,
                                  backgroundColor: '#336598',
                                  borderColor: 'black',
                                  padding: 10
                                }}
                              >
                                <View style={{flex: 20}}>
                                  <TouchableOpacity
                                    onPress={() =>
                                      this.props.redirectToItemDetail(item)
                                    }
                                    delayLongPress={1000}
                                    style={{
                                      backgroundColor: '#fff',
                                      padding: 5,
                                      borderTopLeftRadius: 20,
                                      borderTopRightRadius: 20
                                    }}
                                  >
                                    <Text
                                      numberOfLines={2}
                                      style={
                                        item.name && item.name.length <= 32
                                          ? {fontSize: 20, maxWidth: '75%'}
                                          : {fontSize: 16, maxWidth: '75%'}
                                      }
                                    >
                                      {item.name}
                                    </Text>
                                  </TouchableOpacity>
                                  <Text
                                    numberOfLines={1}
                                    ellipsizeMode="tail"
                                    style={{
                                      color: '#fff',
                                      fontSize: 20,
                                      fontWeight: '600',
                                      maxWidth: '70%'
                                    }}
                                  >
                                    {item.sku}
                                  </Text>
                                  <View
                                    style={{
                                      backgroundColor: '#95b0e5',
                                      paddingLeft: 3,
                                      paddingRight: 3
                                    }}
                                  >
                                    <View
                                      style={{
                                        maxWidth: '70%',
                                        flexDirection: 'row'
                                      }}
                                    >
                                      {item.location !== null &&
                                        item.location !== '' &&
                                        item.location !== undefined && (
                                          <View
                                            style={{
                                              flex: 1,
                                              flexDirection: 'row',
                                              alignItems: 'baseline',
                                              height: 25
                                            }}
                                          >
                                            <Text>L1 : </Text>
                                            <Text
                                              numberOfLines={1}
                                              ellipsizeMode="tail"
                                              style={{
                                                fontSize: 20,
                                                fontWeight: 'bold',
                                                paddingRight: 10
                                              }}
                                            >
                                              {item.location}
                                            </Text>
                                          </View>
                                        )}
                                      {item.custom_product_1 !== null &&
                                        item.custom_product_1 !== '' &&
                                        item.custom_product_1 !== undefined && (
                                          <View
                                            style={{
                                              flex: 1,
                                              flexDirection: 'row',
                                              alignItems: 'baseline',
                                              height: 25
                                            }}
                                          >
                                            <Text>C1:</Text>
                                            <Text
                                              numberOfLines={1}
                                              ellipsizeMode="tail"
                                              style={{
                                                fontSize: 20,
                                                fontWeight: 'bold'
                                              }}
                                            >
                                              {item.custom_product_1}
                                            </Text>
                                          </View>
                                        )}
                                    </View>
                                  </View>
                                  <View
                                    style={{
                                      backgroundColor: '#d3def4',
                                      padding: 3,
                                      borderBottomLeftRadius: 20,
                                      borderBottomRightRadius: 20
                                    }}
                                  >
                                    <Text
                                      style={{fontSize: 20, maxWidth: '75%'}}
                                      numberOfLines={1}
                                      ellipsizeMode="tail"
                                    >
                                      {item &&
                                        item.barcodes.length > 0 &&
                                        item.barcodes[0].barcode}
                                    </Text>
                                  </View>
                                </View>

                                <View
                                  style={{
                                    flex: 5,
                                    borderBottomRightRadius: 12,
                                    borderTopRightRadius: 12,
                                    position: 'absolute',
                                    right: 6,
                                    width: '25%',
                                    height: '100%',
                                    bottom: 0,
                                    top: 10
                                  }}
                                >
                                  <View
                                    style={{
                                      backgroundColor: '#fff',
                                      shadowColor: '#000',
                                      shadowOffset: {width: -5, height: 2},
                                      shadowOpacity: 0.25,
                                      shadowRadius: 3.84,
                                      elevation: 3,
                                      borderRadius: 12,
                                      borderWidth: 8,
                                      borderColor: '#336598'
                                    }}
                                  >
                                    <Text
                                      style={{
                                        position: 'absolute',
                                        textAlign: 'center',
                                        fontSize: 18,
                                        fontWeight: '600',
                                        backgroundColor: '#fff',
                                        opacity: 0.7,
                                        bottom: 0,
                                        right: 0,
                                        left: 0,
                                        marginLeft: 'auto',
                                        marginRight: 'auto',
                                        zIndex: 999
                                      }}
                                    >
                                      {item.scanned_qty}/
                                      {item.qty_remaining + item.scanned_qty}
                                    </Text>
                                    <Image
                                      defaultSource={placeholder}
                                      source={{
                                        uri:
                                          item.images && item.images.length > 0
                                            ? item.images[0].image
                                            : placeholder
                                      }}
                                      style={{
                                        height: '100%',
                                        width: '100%',
                                        resizeMode: 'contain',
                                        borderRadius: 12
                                      }}
                                    />
                                  </View>
                                </View>
                              </View>
                            ) : (
                              <View
                                key={index}
                                style={{
                                  margin: 0,
                                  borderRadius: 30,
                                  borderWidth: 4,
                                  borderColor: 'black',
                                  backgroundColor: '#3f5163',
                                  padding: 10
                                }}
                              >
                                <View style={{flexDirection: 'row'}}>
                                  <View
                                    style={{
                                      height: 5,
                                      flex: 8,
                                      backgroundColor: '#fff',
                                      borderRadius: 3,
                                      position: 'relative'
                                    }}
                                  >
                                    <Text
                                      style={{
                                        fontSize: 18,
                                        fontWeight: 'bold',
                                        position: 'absolute',
                                        left: '50%',
                                        top: -7,
                                        marginLeft: 'auto',
                                        marginRight: 'auto',
                                        backgroundColor: '#3f5163',
                                        paddingLeft: 4,
                                        paddingRight: 4,
                                        color: '#fff'
                                      }}
                                    >
                                      KIT
                                    </Text>
                                  </View>
                                  <View style={{flex: 2}}>
                                    <Text
                                      style={{
                                        textAlign: 'center',
                                        color: '#fff',
                                        fontSize: 18,
                                        marginTop: -6,
                                        fontWeight: 'bold'
                                      }}
                                    >
                                      {item.scanned_qty}/
                                      {item.qty_remaining + item.scanned_qty}
                                    </Text>
                                  </View>
                                </View>
                                <View style={{flexDirection: 'row'}}>
                                  <View style={{flex: 8}}>
                                    <TouchableOpacity
                                      onPress={() =>
                                        this.props.redirectToItemDetail(item)
                                      }
                                      delayLongPress={1000}
                                    >
                                      <Text
                                        numberOfLines={2}
                                        ellipsizeMode="tail"
                                        style={{
                                          fontSize: 16,
                                          color: '#fff',
                                          fontWeight: '600',
                                          paddingRight: 3,
                                          paddingLeft: 3
                                        }}
                                      >
                                        {item.name}
                                      </Text>
                                    </TouchableOpacity>
                                    {/*<TouchableOpacity onPress={() => this.props.clickScan(Order.unscanned_items[0].child_items[0]) }>*/}
                                    <Text
                                      numberOfLines={1}
                                      ellipsizeMode="tail"
                                      style={{
                                        fontSize: 20,
                                        color: '#fff',
                                        fontWeight: '600',
                                        paddingRight: 3,
                                        paddingLeft: 3,
                                        marginBottom: 2
                                      }}
                                    >
                                      {item.sku}
                                    </Text>
                                    {/*</TouchableOpacity>*/}
                                  </View>
                                  {item.images.length > 0 &&
                                    item.images[0].image && (
                                      <View
                                        style={{
                                          flex: 2,
                                          borderRadius: 12,
                                          borderWidth: 12,
                                          maxHeight: 100,
                                          borderColor: '#3f5163'
                                        }}
                                      >
                                        {/* <Image source={{ uri: item.images && item.images.length > 0 ? item.images[0].image : placeholder }}
                                              style={{ height: "100%", width: "100%", resizeMode: 'contain', borderRadius: 12 }} /> */}
                                        {item?.images[0]?.image ? (
                                          <Image
                                            defaultSource={placeholder}
                                            style={{
                                              height: '90%',
                                              width: '90%',
                                              resizeMode: 'contain',
                                              borderRadius: 10
                                            }}
                                            source={{
                                              uri: item?.images[0]?.image
                                            }}
                                          />
                                        ) : (
                                          <Image
                                            style={{
                                              height: '90%',
                                              width: '90%',
                                              resizeMode: 'contain',
                                              borderRadius: 10
                                            }}
                                            source={placeholder}
                                          />
                                        )}
                                      </View>
                                    )}
                                </View>
                                {item &&
                                  item.child_items &&
                                  item.child_items.length > 0 &&
                                  item.child_items.map((childItem, index) => {
                                    return (
                                      <View
                                        key={index}
                                        style={{
                                          flexDirection: 'row',
                                          marginBottom: 5,
                                          backgroundColor: '#fff',
                                          borderBottomRightRadius: 20,
                                          borderTopRightRadius: 20
                                        }}
                                      >
                                        <View style={{flex: 20}}>
                                          <View
                                            style={{backgroundColor: '#fff'}}
                                          ></View>
                                          <TouchableOpacity
                                            onPress={() =>
                                              this.props.redirectToItemDetail(
                                                childItem
                                              )
                                            }
                                            delayLongPress={1000}
                                            style={{
                                              backgroundColor: '#fff',
                                              paddingLeft: 5,
                                              paddingTop: 10
                                            }}
                                          >
                                            <Text
                                              numberOfLines={2}
                                              ellipsizeMode="tail"
                                              style={
                                                childItem.name &&
                                                childItem.name.length <= 32
                                                  ? {
                                                      fontSize: 20,
                                                      width: '75%'
                                                    }
                                                  : {
                                                      fontSize: 16,
                                                      width: '75%'
                                                    }
                                              }
                                            >
                                              {childItem.name}
                                            </Text>
                                          </TouchableOpacity>
                                          <Text
                                            numberOfLines={1}
                                            ellipsizeMode="tail"
                                            style={{
                                              backgroundColor: '#3f5163',
                                              color: '#fff',
                                              fontSize: 20,
                                              fontWeight: '600',
                                              width: '75%'
                                            }}
                                          >
                                            {childItem.sku}
                                          </Text>
                                          <View
                                            style={{
                                              backgroundColor: '#a4b4c5',
                                              height: 25
                                            }}
                                          >
                                            <View
                                              style={{
                                                flexDirection: 'row',
                                                width: '65%'
                                              }}
                                            >
                                              {childItem.location !== null &&
                                                childItem.location !== '' && (
                                                  <View
                                                    style={{
                                                      flex: 1,
                                                      flexDirection: 'row',
                                                      alignItems: 'baseline',
                                                      height: 25
                                                    }}
                                                  >
                                                    <Text>L1 : </Text>
                                                    <Text
                                                      numberOfLines={1}
                                                      ellipsizeMode="tail"
                                                      style={{
                                                        fontSize: 20,
                                                        fontWeight: 'bold',
                                                        paddingRight: 10
                                                      }}
                                                    >
                                                      {childItem.location}
                                                    </Text>
                                                  </View>
                                                )}
                                              {childItem.custom_product_1 !==
                                                null &&
                                                childItem.custom_product_1 !==
                                                  '' && (
                                                  <View
                                                    style={{
                                                      flex: 1,
                                                      flexDirection: 'row',
                                                      alignItems: 'baseline',
                                                      height: 25
                                                    }}
                                                  >
                                                    <Text>C1:</Text>
                                                    <Text
                                                      numberOfLines={1}
                                                      ellipsizeMode="tail"
                                                      style={{
                                                        fontSize: 20,
                                                        fontWeight: 'bold'
                                                      }}
                                                    >
                                                      {
                                                        childItem.custom_product_1
                                                      }
                                                    </Text>
                                                  </View>
                                                )}
                                            </View>
                                          </View>
                                          <View
                                            style={{
                                              backgroundColor: '#cdd7e2',
                                              borderBottomRightRadius: 20
                                            }}
                                          >
                                            <Text
                                              numberOfLines={1}
                                              ellipsizeMode="tail"
                                              style={{
                                                width: '75%',
                                                fontSize: 20
                                              }}
                                            >
                                              {childItem &&
                                                childItem.barcodes.length > 0 &&
                                                childItem.barcodes[0].barcode}
                                            </Text>
                                          </View>
                                        </View>
                                        <View
                                          style={{
                                            flex: 5,
                                            borderBottomRightRadius: 12,
                                            paddingTop: 10,
                                            position: 'absolute',
                                            width: '25%',
                                            right: 0,
                                            top: 0,
                                            bottom: 0
                                          }}
                                        >
                                          <View
                                            style={{
                                              backgroundColor: '#fff',
                                              shadowColor: '#000',
                                              shadowOffset: {
                                                width: -5,
                                                height: 2
                                              },
                                              shadowOpacity: 0.25,
                                              shadowRadius: 3.84,
                                              elevation: 3,
                                              borderRadius: 12,
                                              borderWidth: 8,
                                              borderColor: '#3f5163'
                                            }}
                                          >
                                            <Text
                                              style={{
                                                position: 'absolute',
                                                textAlign: 'center',
                                                fontSize: 18,
                                                fontWeight: '600',
                                                backgroundColor: '#fff',
                                                opacity: 0.7,
                                                bottom: 0,
                                                right: 0,
                                                left: 0,
                                                marginLeft: 'auto',
                                                marginRight: 'auto',
                                                zIndex: 999
                                              }}
                                            >
                                              {childItem.scanned_qty}/
                                              {childItem.qty_remaining +
                                                childItem.scanned_qty}
                                            </Text>
                                            {/* <Image source={{ uri: childItem.images && childItem.images.length > 0 ? childItem.images[0].image : placeholder }}
                                                    style={{ height: "100%", width: "100%", resizeMode: 'contain', borderRadius: 12 }} /> */}
                                            {childItem?.images[0]?.image ? (
                                              <Image
                                                defaultSource={placeholder}
                                                style={{
                                                  height: '90%',
                                                  width: '90%',
                                                  resizeMode: 'contain',
                                                  borderRadius: 10
                                                }}
                                                source={{
                                                  uri: childItem?.images[0]
                                                    ?.image
                                                }}
                                              />
                                            ) : (
                                              <Image
                                                style={{
                                                  height: '90%',
                                                  width: '90%',
                                                  resizeMode: 'contain',
                                                  borderRadius: 10
                                                }}
                                                source={placeholder}
                                              />
                                            )}
                                          </View>
                                        </View>
                                      </View>
                                    );
                                  })}
                              </View>
                            )}
                          </View>
                        );
                      })
                    ) : (
                      <View style={globalStyles.p_10}>
                        {/* <Text style={styles.scannedItemNameText}>
                              No more item remaining to scan
                            </Text> */}
                      </View>
                    )}
                  </ScrollView>
                </View>
              </View>
            )}
          </View>
        )}
      </React.Fragment>
    );
  }
}
